export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1695634580213-c384a6201eee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY6OTV8MHwxfHNlYXJjaHwzfHxmcmVuY2glMjByZWQlMjB3aW5lJTIwYm90dGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc4OTgwNzg3Nnww&ixlib=rb-4.1.0&q=85",
  cellar: "https://images.unsplash.com/photo-1655574282139-144861418cc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx3aW5lJTIwY2VsbGFyJTIwYm9yZGVhdXglMjBmcmFuY2V8ZW58MHx8fHwxNzg5ODA3ODc2fDA&ixlib=rb-4.1.0&q=85",
  restaurant: "https://images.pexels.com/photos/38269543/pexels-photo-38269543.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CATEGORIES = [
  {
    id: "rouge",
    label: "Vins rouges",
    subtitle: "Caractère & terroir",
    image: "https://images.pexels.com/photos/10011983/pexels-photo-10011983.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "blanc",
    label: "Vins blancs",
    subtitle: "Fraîcheur & finesse",
    image: "https://images.unsplash.com/photo-1743184579851-5ec9972100b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxjaGFtcGFnbmUlMjBib3R0bGUlMjBsdXh1cnklMjByZXN0YXVyYW50fGVufDB8fHx8MTc4OTgwNzg3Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "champagne",
    label: "Champagnes",
    subtitle: "Bulles de fête",
    image: "https://images.unsplash.com/photo-1623428454697-08da4a100602?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxjaGFtcGFnbmUlMjBib3R0bGUlMjBsdXh1cnklMjByZXN0YXVyYW50fGVufDB8fHx8MTc4OTgwNzg3Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "coffret",
    label: "Coffrets cadeaux",
    subtitle: "Prêts à offrir",
    image: "https://images.unsplash.com/photo-1592119748016-a61c40a44320?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY6OTV8MHwxfHNlYXJjaHwxfHxmcmVuY2glMjByZWQlMjB3aW5lJTIwYm90dGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc4OTgwNzg3Nnww&ixlib=rb-4.1.0&q=85",
  },
];

export const RESTAURANT = {
  name: "Le Bistroquet",
  address: "12 rue des Brasseries, 90000 Belfort",
  hours: "Mardi – Samedi · 10h00 – 19h00",
  phone: "06 47 24 02 68",
};

export const PICKUP_SLOTS = [
  "Aujourd'hui — fin de journée",
  "Demain — midi",
  "Demain — soir",
  "Samedi — dans la journée",
];

export const volumeDiscountRate = (qty) => (qty >= 144 ? 1.0 : qty >= 72 ? 0.5 : qty >= 36 ? 0.3 : 0);
